import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b7ec76dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "state-map-component" }
const _hoisted_2 = { class: "state-map-inner" }
const _hoisted_3 = { class: "state-map-intro" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "state-map-icon",
  src: "/images/icon-map.svg",
  alt: "",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "state-map-eyebrow" }, "Place of Prosecution", -1))
const _hoisted_6 = { class: "state-map-lead" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "state-map-title" }, "All Prosecutions by State", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state-map-sub" }, "Hover any state for the count and share of total documented cases.", -1))
const _hoisted_9 = { class: "state-map-grid" }
const _hoisted_10 = ["href", "onMouseenter"]
const _hoisted_11 = { class: "state-abbr" }
const _hoisted_12 = { class: "state-map-legend" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-bar" }, null, -1))
const _hoisted_15 = { class: "tt-name" }
const _hoisted_16 = { class: "tt-pct" }
const _hoisted_17 = { class: "tt-count" }

import { computed, ref } from 'vue';
import { PrisonerRecord } from '@/@types/types';

interface Props {
  records: PrisonerRecord[];
}
interface Cell { abbr: string; row: number; col: number }

export default /*#__PURE__*/_defineComponent({
  __name: 'StateMapComponent',
  props: {
    records: {}
  },
  setup(__props: any) {

const props = __props;

const stateNames: Record<string, string> = {
  AL: 'Alabama',        AK: 'Alaska',         AZ: 'Arizona',
  AR: 'Arkansas',       CA: 'California',     CO: 'Colorado',
  CT: 'Connecticut',    DE: 'Delaware',       DC: 'District of Columbia',
  FL: 'Florida',        GA: 'Georgia',        HI: 'Hawaii',
  ID: 'Idaho',          IL: 'Illinois',       IN: 'Indiana',
  IA: 'Iowa',           KS: 'Kansas',         KY: 'Kentucky',
  LA: 'Louisiana',      ME: 'Maine',          MD: 'Maryland',
  MA: 'Massachusetts',  MI: 'Michigan',       MN: 'Minnesota',
  MS: 'Mississippi',    MO: 'Missouri',       MT: 'Montana',
  NE: 'Nebraska',       NV: 'Nevada',         NH: 'New Hampshire',
  NJ: 'New Jersey',     NM: 'New Mexico',     NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota',   OH: 'Ohio',
  OK: 'Oklahoma',       OR: 'Oregon',         PA: 'Pennsylvania',
  RI: 'Rhode Island',   SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee',      TX: 'Texas',          UT: 'Utah',
  VT: 'Vermont',        VA: 'Virginia',       WA: 'Washington',
  WV: 'West Virginia',  WI: 'Wisconsin',      WY: 'Wyoming',
  PR: 'Puerto Rico',
};

// abbr, row, col (1-indexed); same layout as Intercept's Trial and Terror
const grid: Cell[] = [
  { abbr: 'ME', row: 1, col: 11 },
  { abbr: 'WA', row: 2, col: 1 }, { abbr: 'ID', row: 2, col: 2 }, { abbr: 'MT', row: 2, col: 3 }, { abbr: 'ND', row: 2, col: 4 }, { abbr: 'MN', row: 2, col: 5 }, { abbr: 'WI', row: 2, col: 6 }, { abbr: 'MI', row: 2, col: 7 }, { abbr: 'PA', row: 2, col: 8 }, { abbr: 'VT', row: 2, col: 9 }, { abbr: 'NH', row: 2, col: 10 }, { abbr: 'MA', row: 2, col: 11 },
  { abbr: 'OR', row: 3, col: 1 }, { abbr: 'NV', row: 3, col: 2 }, { abbr: 'WY', row: 3, col: 3 }, { abbr: 'SD', row: 3, col: 4 }, { abbr: 'IA', row: 3, col: 5 }, { abbr: 'IN', row: 3, col: 6 }, { abbr: 'OH', row: 3, col: 7 }, { abbr: 'MD', row: 3, col: 8 }, { abbr: 'NY', row: 3, col: 9 }, { abbr: 'CT', row: 3, col: 10 }, { abbr: 'RI', row: 3, col: 11 },
  { abbr: 'CA', row: 4, col: 1 }, { abbr: 'UT', row: 4, col: 2 }, { abbr: 'CO', row: 4, col: 3 }, { abbr: 'NE', row: 4, col: 4 }, { abbr: 'MO', row: 4, col: 5 }, { abbr: 'IL', row: 4, col: 6 }, { abbr: 'KY', row: 4, col: 7 }, { abbr: 'DC', row: 4, col: 8 }, { abbr: 'DE', row: 4, col: 9 }, { abbr: 'NJ', row: 4, col: 10 },
  { abbr: 'AZ', row: 5, col: 2 }, { abbr: 'NM', row: 5, col: 3 }, { abbr: 'KS', row: 5, col: 4 }, { abbr: 'AR', row: 5, col: 5 }, { abbr: 'TN', row: 5, col: 6 }, { abbr: 'WV', row: 5, col: 7 }, { abbr: 'VA', row: 5, col: 8 }, { abbr: 'NC', row: 5, col: 9 },
  { abbr: 'OK', row: 6, col: 4 }, { abbr: 'LA', row: 6, col: 5 }, { abbr: 'MS', row: 6, col: 6 }, { abbr: 'AL', row: 6, col: 7 }, { abbr: 'GA', row: 6, col: 8 }, { abbr: 'SC', row: 6, col: 9 },
  { abbr: 'AK', row: 7, col: 1 }, { abbr: 'HI', row: 7, col: 2 }, { abbr: 'TX', row: 7, col: 4 }, { abbr: 'FL', row: 7, col: 10 }, { abbr: 'PR', row: 7, col: 11 },
];

// Build a name → abbr lookup so records with full state names match
const nameToAbbr = computed(() => {
  const m: Record<string, string> = {};
  Object.entries(stateNames).forEach(([abbr, name]) => {
    m[name.toLowerCase()] = abbr;
    m[abbr.toLowerCase()] = abbr;
  });
  return m;
});

// Reactive counts per state, recomputed every time props.records changes
const counts = computed(() => {
  const c: Record<string, number> = {};
  Object.keys(stateNames).forEach(a => { c[a] = 0; });
  props.records.forEach(r => {
    const raw = (r as any).State;
    if (!raw) return;
    const list = Array.isArray(raw) ? raw : [raw];
    list.forEach((entry: string) => {
      if (!entry || typeof entry !== 'string') return;
      const abbr = nameToAbbr.value[entry.toLowerCase()];
      if (abbr) c[abbr]++;
    });
  });
  return c;
});

const total = computed(() => Object.values(counts.value).reduce((a, b) => a + b, 0));
const max = computed(() => Math.max(...Object.values(counts.value), 1));

// The lead sentence + highlighted cell follow whichever state the
// cursor is over. Default to the single most-prosecuted state so the
// page opens on the headline figure (mirrors the Intercept reference).
const activeAbbr = ref<string | null>(null);
const topAbbr = computed(() => {
  let best = 'NY', bestN = -1;
  Object.keys(stateNames).forEach(a => {
    if (counts.value[a] > bestN) { bestN = counts.value[a]; best = a; }
  });
  return best;
});
const leadAbbr = computed(() => activeAbbr.value || topAbbr.value);
const leadName = computed(() => stateNames[leadAbbr.value]);
const leadPct = computed(() => {
  const n = counts.value[leadAbbr.value] || 0;
  return total.value > 0 ? Math.round((n / total.value) * 100) : 0;
});

const colorFor = (n: number): string => {
  if (n <= 0) return '#14141a';
  // Log-scale so single-defendant states are visible
  const t = Math.min(1, Math.log(n + 1) / Math.log(max.value + 1));
  // 3-stop interpolation: dark → site brand blue → magenta
  let r: number, g: number, b: number;
  if (t < 0.5) {
    const u = t / 0.5;
    r = Math.round(0x14 + u * (0x56 - 0x14));
    g = Math.round(0x14 + u * (0x60 - 0x14));
    b = Math.round(0x1a + u * (0xfe - 0x1a));
  } else {
    const u = (t - 0.5) / 0.5;
    r = Math.round(0x56 + u * (0xc5 - 0x56));
    g = Math.round(0x60 + u * (0x27 - 0x60));
    b = Math.round(0xfe + u * (0x9a - 0xfe));
  }
  const hex = (v: number) => v.toString(16).padStart(2, '0');
  return `#${hex(r)}${hex(g)}${hex(b)}`;
};

// Tooltip state
const tipVisible = ref(false);
const tipName = ref('');
const tipCount = ref(0);
const tipPct = ref(0);
const tipX = ref(0);
const tipY = ref(0);

const showTip = (abbr: string, e: MouseEvent) => {
  activeAbbr.value = abbr;            // drive the lead sentence + highlight
  tipName.value = stateNames[abbr];
  tipCount.value = counts.value[abbr];
  tipPct.value = total.value > 0 ? Math.round((tipCount.value / total.value) * 100) : 0;
  tipVisible.value = true;
  moveTip(e);
};

const moveTip = (e: MouseEvent) => {
  const offset = 14;
  let x = e.clientX + offset;
  let y = e.clientY + offset;
  if (x + 240 > window.innerWidth) x = e.clientX - 240 - offset;
  if (y + 80 > window.innerHeight) y = e.clientY - 80 - offset;
  tipX.value = x;
  tipY.value = y;
};

const hideTip = () => { tipVisible.value = false; };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("strong", null, _toDisplayString(leadPct.value) + " percent", 1),
          _createTextVNode(" of documented U.S. political prisoners have been prosecuted in "),
          _createElementVNode("strong", null, _toDisplayString(leadName.value), 1),
          _createTextVNode(". ")
        ])
      ]),
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(grid, (cell) => {
          return _createElementVNode("a", {
            key: cell.abbr,
            href: `/database?state=${encodeURIComponent(stateNames[cell.abbr])}`,
            class: _normalizeClass(["state-cell", { 'is-active': cell.abbr === leadAbbr.value }]),
            style: _normalizeStyle({ gridRow: String(cell.row), gridColumn: String(cell.col), background: colorFor(counts.value[cell.abbr]) }),
            onMouseenter: (e) => showTip(cell.abbr, e),
            onMousemove: moveTip,
            onMouseleave: hideTip
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(cell.abbr), 1)
          ], 46, _hoisted_10)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("span", null, _toDisplayString(max.value), 1)
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (tipVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "state-map-tooltip",
              style: _normalizeStyle({ left: tipX.value + 'px', top: tipY.value + 'px' })
            }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(tipName.value), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(tipPct.value > 0 ? tipPct.value : '<1') + "% of all defendants", 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(tipCount.value) + " defendant" + _toDisplayString(tipCount.value === 1 ? '' : 's'), 1)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})